import { useMutation } from "@tanstack/react-query";
import { updateGoogleBusinessProfileSocialLinks } from "../../api/bReviewsApi";

export const useUpdateGoogleBusinessProfileSocialLinks = () => {
  return useMutation({
    mutationFn: ({ locationId, data }) =>
      updateGoogleBusinessProfileSocialLinks(locationId, data),
  });
};
